<template>
	<div class="newsDetail">
		<div class="relative box1">
		  <img :src="windowWidth > 820?'https://qiniuimg.wurun.net/b5.jpg':'https://qiniuimg.wurun.net/m_bg5.jpg'" alt="">
			<div class="text">
				<div class="fs45 fw mt30 cor-27">新闻动态</div>
				<div class="fs22 let-spc6 cor-27 mt30">了解你想了解的五润与行业动态</div>
				<div class="cor-8f fs10 let-spc6 relative">news information</div>
			</div>
		</div>
		<div class="path">
			<div class="w1200 flex fs16">当前位置：<p @click="go" class="cor-27">新闻动态</p> &nbsp; <p class="cor-d">>></p> &nbsp;{{label == 0?'五润动态':'行业动态'}}</div>
		</div>
		<div class="w1200 detail">
			<div class="tit">{{data.newTitle}}</div>
			<div class="time">发布时间：{{data.addTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}&nbsp;&nbsp;来源：{{data.source}}</div>
			<!-- <div class="text">{{data.text}}</div> -->
			<div class="cont" v-html="data.newContel">
			</div>
			<!-- <div class="flex align-items just-between more">
				<div>上一篇：没有了</div>
				<div class="no">下一篇：没有了</div>
			</div> -->
		</div>
		<rightTab v-if="windowWidth > 820"/>
	</div>
</template>

<script>
	// import marked from 'marked'
	// import hljs from "highlight.js";
	// import 'highlight.js/styles/monokai-sublime.css';
	import rightTab from "@/components/rightTab.vue"
	import {
		parseTime,
		renderTime
	} from '@/utils/index.js'
	require('../../style/css_w/newsDetail.css');
	export default{
		components: {
			rightTab
		},
			filters: {
			parseTime: parseTime
		},
		data() {
			return{
				label:'',
				windowWidth:'',
				data:''
			}
		},
		created(){
			this.windowWidth  = document.body.clientWidth
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
			if(JSON.parse(sessionStorage.getItem("newsData"))){
				this.data = JSON.parse(sessionStorage.getItem("newsData"))
			}
			if(JSON.parse(sessionStorage.getItem("label"))){
				this.label = JSON.parse(sessionStorage.getItem("label"))
			}
		},
		mounted(){
			document.documentElement.scrollTop = 0
		},
		methods:{
			go() {
				this.$router.push({
					path:'/news'
				})
			}
		}
	}
</script>

<style scoped>
	
</style>